//
//
//
//
//
//
//
//
//
//
//

// import api from './api';
import Vtabbar from './components/tabbar';
import store from './store';
import api from './api/'

export default {
    name: 'app',
    components: {
        Vtabbar,
    },
    data() {
        return {
            show: this.$store.state.showTabber,
        };
    },
    mounted() {
        // api.vega.getHot();
    },
    created() {
        this.$store.dispatch('init');
        // 如果有code 并且是微信环境 && 非登录状态
        if (this.getUrlCode() && window.navigator.userAgent.match('MicroMessenger') && !this.$store.state.isLogin) {
            // // 通过用户授权，获取code,然后查询openid，openid存在的话后台模拟一次用户登录返回用户信息（token）
            // api.vega.wechat.sweeplogin({code: this.getUrlCode()})
            //     .then(res => {
            //         if (res.data.code === 0 && res.data.data) {
            //             // 存在：更新用户信息，并保持登录。
            //             this.$store.dispatch('updataUserInfo', res.data.data)
            //         } else {
            //             // 不存在：获取openid并记录openid，登录的时候绑定
            //             this.getOpenId();
            //         }
            //     })
            // this.getOpenId();
        }
    },
    methods: {
        // 获取url参数
        getUrlCode() {
           // 获取url code
            return window.location.href.indexOf('?') !== -1 && 
            window.location.href.split('?')[1].split('&')[0].split('=')[1];
        },
        getOpenId () {
            api.vega.wechat.getOpenId({code: this.getUrlCode()})
                .then(res => {
                    if (res.data.data.openid) {
                        this.$store.commit('updataOpenId', res.data.data.openid);
                        localStorage.setItem('OPEN_ID', res.data.data.openid);
                        const params = {
                            loginType: 3, // 微信登录
                            loginName: res.data.data.openid,
                        }
                        this.$store.dispatch('doLogOrReg', params);
                    }
                })
        }
    },
};
